import { useLang } from "@/i18n/LanguageContext";
import { Globe } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function LanguageSelector({ dark = false, testId = "language-selector" }) {
  const { lang, setLang, langs } = useLang();
  const current = langs.find((l) => l.code === lang);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid={testId}
          className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-sm font-medium transition-colors ${
            dark
              ? "border-white/30 text-white hover:bg-white/10"
              : "border-border text-foreground hover:bg-secondary"
          }`}
          aria-label="Select language"
        >
          <Globe className="h-4 w-4" />
          <span className="uppercase">{current?.code}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" data-testid="language-menu">
        {langs.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`language-option-${l.code}`}
            onClick={() => setLang(l.code)}
            className={l.code === lang ? "font-semibold text-primary" : ""}
          >
            {l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
